import { AxiosRequestHeaders } from "axios";
import {getAuth} from "../modules/auth";

// http://localhost:4200/landing?query=1#2
//
// window.location.hash: "#2"
// window.location.host: "localhost:4200"
// window.location.hostname: "localhost"
// window.location.href: "http://localhost:4200/landing?query=1#2"
// window.location.origin: "http://localhost:4200"
// window.location.pathname: "/landing"
// window.location.port: "4200"
// window.location.protocol: "http:"
// window.location.search: "?query=1"

// LOCALHOST
const STAGE_DOMAIN     = `${process.env.REACT_APP_DOMAIN_STAGE}`;
const STAGE_API_DOMAIN = `${process.env.REACT_APP_API_DOMAIN_STAGE}`

let domain = window.location.origin;

if (domain === STAGE_DOMAIN) {
    domain = STAGE_API_DOMAIN;
}

const ROOT_URL = `${domain}`;
const API_URL = process.env.REACT_APP_API_URL;

export const getBaseUrl = () => {
    if (ROOT_URL) {
        return ROOT_URL;
    }
    throw new Error('Base Url not valid, check the env file!');
};

export const getBaseApiUrl = () => {
    if (ROOT_URL && API_URL) {
        return ROOT_URL + API_URL;
    }
    throw new Error('Base Api Url not valid, check the env file!');
};

export const getHeaders = () : AxiosRequestHeaders => {
    const auth = getAuth();
    let apiToken = "";
    if (auth && auth.api_token) {
        apiToken = auth.api_token;
    }
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${apiToken}`
    }
};
